import React from "react";

import {Button, ModalBody, Modal} from 'reactstrap';

import {Card, CardContent} from "@material-ui/core";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import CustomerComponent from "./Parts/CustomerComponent";
import {Objects} from "../index";
import {confirmAlert} from "react-confirm-alert";

export default class WorkOrder extends Framework.Components.Object {
	constructor(props) {
		/**
		 *  @typedef {Work_Orders_Object} this.state
		 */
		super(props, Types.Work_Orders._name);
		this.state.updateEmailModal = false;
		this.state.customerAddModalOpen = false;

		this.sendReceipt = this.sendReceipt.bind(this);
		this.afterCustomerSave = this.setNewObject('customer');
	}

	handleSubmit = async (ev) => {
		// Past estimated dates on existing work orders are allowed; only block creating a new past date on create (AddWorkOrder).
		await super.handleSubmit(ev);
	}

	saveWorkOrderStatus = async (status) => {
		if (!this.state.pkey) {
			return;
		}
		const wo = new API.BuildClass(Types.Work_Orders._name, API.RequestType.UPDATE);
		wo.object = {
			pkey: this.state.pkey,
			status,
		};
		try {
			const response = await wo.submit(null, API.RequestType.UPDATE, true);
			const nextState = { status };
			if (status !== 'Completed') {
				nextState.completed_date = null;
			} else if (response?.completed_date) {
				nextState.completed_date = response.completed_date;
			}
			this.setState(nextState);
			API.Toast.success('Status saved.', {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 3000,
			});
		} catch (err) {
			API.Toast.error(err?.message || 'Could not save status.', {
				position: API.Toast.POSITION.TOP_RIGHT,
			});
			throw err;
		}
	}

	handleStatusChange = (e) => {
		const status = e.target.value;
		const previousStatus = this.state.status || 'Received';

		if (previousStatus === 'Completed' && status !== 'Completed') {
			confirmAlert({
				title: 'Reopen work order?',
				message: 'Changing status away from Completed will clear the completed date and allow line edits again. Continue?',
				buttons: [
					{
						label: 'Yes, reopen',
						onClick: async () => {
							this.setState({ status });
							try {
								await this.saveWorkOrderStatus(status);
							} catch (err) {
								this.setState({ status: previousStatus });
							}
						},
					},
					{
						label: 'Cancel',
						onClick: () => {
							this.setState({ status: previousStatus });
						},
					},
				],
			});
			return;
		}

		this.setState({ status });
		this.saveWorkOrderStatus(status);
	}

	reloadContractHeader = async () => {
		const pkey = this.state.pkey || this.props.id;
		if (!pkey) {
			return;
		}
		try {
			let model = new API.BuildClass(Types.Work_Orders._name, API.RequestType.READ);
			model.object = {pkey};
			const response = await model.submit(null, 'GET', true);
			const o = response?.response ?? response?.object ?? response;
			if (!o || typeof o !== 'object') {
				return;
			}
			this.setState({
				sub_total_amount: o.sub_total_amount,
				tax_amount: o.tax_amount,
				amount: o.amount,
				remaining: o.remaining,
				cc_fees: o.cc_fees,
				tax_json: o.tax_json,
				completed_date: o.completed_date,
				status: o.status,
			});
		} catch (e) {
			// keep existing header totals if refresh fails
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (typeof(this.props.setRemaining) === 'function' && this.state.remaining !== prevState.remaining) {
			this.props.setRemaining(this.state.remaining)
		}
	}

	getCustomerEmail = () => {
		return this.state.customers && this.state.customers.email ? this.state.customers.email : '';
	}

	getLegacyCustomerName = () => {
		const notes = this.state.work_order_notes || '';
		const legacyRegex = /Legacy client information:\s*([^\n\r]+)/gi;
		let match = null;
		let name = '';
		while ((match = legacyRegex.exec(notes)) !== null) {
			name = match[1].trim();
		}
		return name;
	}

	getLegacyCustomerSeed = () => {
		return {
			name: this.getLegacyCustomerName(),
			email: this.state.receipt_email || '',
		};
	}

	handleCustomerCreatedForReceipt = async (data) => {
		if (typeof this.afterCustomerSave === 'function') {
			this.afterCustomerSave(data);
		}
		if (data && data.pkey && this.state.pkey) {
			await this.saveWorkOrderCustomer(data.pkey);
		}
		this.setState({
			customer: data && data.pkey ? data.pkey : this.state.customer,
			customers: data || this.state.customers,
			customerAddModalOpen: false,
			updateEmailModal: false,
		});
	}

	saveWorkOrderCustomer = async (customer) => {
		let workOrder = new API.BuildClass(Types.Work_Orders._name, API.RequestType.UPDATE);
		workOrder.object.pkey = this.state.pkey;
		workOrder.object.customer = customer;
		await workOrder.submit(null, API.RequestType.UPDATE, true);
	}

	//this.props.attemptedSave could be an issue
	sendReceipt = async () => {
		const customerEmail = this.getCustomerEmail();
		if (!this.state.customer || !customerEmail) {
			this.setState({updateEmailModal: true})
			return;
		}
		if (!this.state.pkey || !this.state.pkey) return;
		await this.saveWorkOrderCustomer(this.state.customer);
		//this.state.method = "terminal";
		this.setState({loading: true});
		await this.model.submit(this, 'POST_EMAIL', false).then(() => {
			this.setState({loading: false});
			if (typeof(this.props.attemptedSave) !== "undefined") {
				this.props.attemptedSave(true)
			}
		})

		this.setState({loading: false});
	}

	render() {
		/**
		 * @type {Work_Orders_Properties} properties
		 */
		let properties = this.model.properties;
		/**
		 *  @type {Work_Orders_Object} object
		 */
		let object = this.state;

		return <Card>
			<CardContent>
				<h4 className="section-title">Work Order Details</h4>
				<div>
					<div className={'row'}>
						<div className={'col-12'}>
							<CustomerComponent
								locations={this.props.locations || []}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								onPersistCustomer={this.saveWorkOrderCustomer}
								key={object.customer ? `customer_work_order_${object.customer}` : "customer_work_order"}
							/>
						</div>
					</div>
					<h4 className="section-title">Status</h4>
					<div className={'row'}>
						<div className="col-12">
							<div className="form-group">
								<select
									className="form-control"
									value={object.status || 'Received'}
									onChange={this.handleStatusChange}
								>
									{['Received', 'Awaiting Parts', 'In Progress', 'Ready', 'On Hold', 'Completed'].map(s => (
										<option key={s} value={s}>{s}</option>
									))}
								</select>
							</div>
						</div>
					</div>
					<h4 className="section-title">Assigned Employee</h4>
					<div className={'row'}>
						<div className="col-12">
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									text={'name'}
									update={this.handleSelectPropertyUpdate}
									property={properties.assigned_user}
									value={object.assigned_user}
									error={object.assigned_user_error}
									model={Types.Users._name}
									nullable={true}
									limit={null}
								/>
							</div>
						</div>
					</div>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"description"}
							label={"Work Order Description (Shown On Receipt)"}
							placeholder={"Public description about work order"}
							property={properties.description}
							value={object.description}
							error={object.description_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
					<hr/>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"work_order_notes"}
							label={"Work Order Notes (Shown On Receipt)"}
							placeholder={"Public notes about work order"}
							property={properties.work_order_notes}
							value={object.work_order_notes}
							error={object.work_order_notes_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
					<hr/>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"customer_notes"}
							label={"Customer Notes (Not Shown On Receipt)"}
							placeholder={"Private notes about work order"}
							property={properties.customer_notes}
							value={object.customer_notes}
							error={object.customer_notes_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
				</div>
				<div className={"row"}>

					{object.completed_date !== "" ?
						<div className={"col"}>
							<div className={"form-group"}>
								<Framework.Elements.Date
									label={"Completed Date"}
									value={object.completed_date}
									error={object.completed_date_error}
									property={properties.completed_date}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div> : null}
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.Date
								label={"Estimated Completion Date"}
								value={object.estimated_date}
								error={object.estimated_date_error}
								property={properties.estimated_date}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</div>
				<div className={"row"}>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.sub_total_amount_error}
								value={object.sub_total_amount}
								property={properties.sub_total_amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.tax_amount_error}
								value={object.tax_amount}
								property={properties.tax_amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								label={"Total"}
								error={object.amount_error}
								value={object.amount}
								property={properties.amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
				</div>
				<div className={"row"}>
					<div className={"col-4"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.cc_fees_error}
								value={object.cc_fees}
								property={properties.cc_fees}
								label={"CC Fees Collected"}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col-4"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.remaining_error}
								value={object.remaining}
								property={properties.remaining}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
				</div>

				<div style={{display: 'grid'}}>
					<Button className="primary-button" onClick={this.handleSubmit} style={{justifySelf: 'end'}}>Save</Button>
				</div>
			</CardContent>

			<Modal
				isOpen={this.state.updateEmailModal}
				toggle={() => {this.setState({updateEmailModal: false})}}
				size={"md"}
				backdrop={true}
			>
				<ModalBody>
					<div className={'d-flex flex-column'}>
						<b style={{justifySelf: "center", paddingBottom: '1rem'}}>
							{!this.state.customer
								? 'This work order needs a customer before a receipt can be emailed.'
								: 'The selected customer needs an email address before a receipt can be emailed.'}
						</b>
						{!this.state.customer && this.getLegacyCustomerName() &&
							<p>
								Found legacy customer information: <strong>{this.getLegacyCustomerName()}</strong>
								{this.state.receipt_email ? <> with email <strong>{this.state.receipt_email}</strong></> : null}.
							</p>}
						{this.state.customer && !this.getCustomerEmail() &&
							<p>Please edit the selected customer and add an email address, then try sending the receipt again.</p>}
						<div className={'justify-content-between full-width d-flex py-1'}>
							<Button
								color={'danger'}
								size={"sm"} block={false}
								onClick={() => {this.setState({updateEmailModal: false})}}
							>
								Cancel
							</Button>
							{!this.state.customer &&
								<Button
									color={'success'}
									size={"sm"} block={false}
									onClick={() => this.setState({customerAddModalOpen: true})}
								>
									Create Customer
								</Button>}
						</div>
					</div>
				</ModalBody>
			</Modal>
			<Framework.Elements.UniversalModal
				locations={this.props.locations || []}
				history={this.props.history}
				name={"Customer"}
				object={Objects.Customer}
				showModal={this.state.customerAddModalOpen}
				objectProps={{
					object: this.getLegacyCustomerSeed(),
					hideSave: true
				}}
				handleToggle={() => this.setState({customerAddModalOpen: !this.state.customerAddModalOpen})}
				afterSave={this.handleCustomerCreatedForReceipt}
				url={'customers'}
			/>

		</Card>
	}
}
